import styles from './Footer.module.scss'
import Payment from './Payment/Payment'
import Timer from './Timer/Timer'

const Footer = () => {
  return (
    <div className={styles.container}>
      <Timer />
      <Payment />
    </div>
  )
}

export default Footer